import bg from "../assets/bg.png";
import Backend from "../assets/Backend.png";
import chef from "../assets/chef.png";
import G from "../assets/G.png";
// import gallery01 from "../assets/gallery01.png";
// import gallery02 from "../assets/gallery02.png";
// import gallery03 from "../assets/gallery03.png";
// import gallery04 from "../assets/gallery04.png";
import knife from "../assets/knife.png";
import logo from "../assets/logo.png";
import menu from "../assets/menu.png";
import overlaybg from "../assets/overlaybg.png";
import spoon from "../assets/spoon.svg";
import welcome from "../assets/welcome.png";
import findus from "../assets/findus.png";
import laurels from "../assets/laurels.png";
import award01 from "../assets/award01.png";
import award02 from "../assets/award02.png";
import award03 from "../assets/award03.png";
import award05 from "../assets/award05.png";
import sign from "../assets/sign.png";
import quote from "../assets/quote.png";
import gericht from "../assets/gericht.png";
import bubble from "../assets/airbuble.jpeg";
import navbar_bg from "../assets/navbar_bg.png";
import tempheader from "../assets/tempheader.jpeg";
import history_img from "../assets/history_img.jpg";
import img1 from "../assets/img1.jpg";
import img2 from "../assets/img2.png";
import img3 from "../assets/img3.jpg";
import img4 from "../assets/img4.jpg";
import img5 from "../assets/img5.png";
import img6 from "../assets/img6.jpg";
import img7 from "../assets/img7.jpg";
import img8 from "../assets/img8.jpg";
import mealIcon from "../assets/meals_icon.png";
import customerIcon from "../assets/customer_icon.png";
import starIcon from "../assets/star_icon.png";

export default {
  bg,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  history_img,
  chef,
  G,
  // gallery01,
  // gallery02,
  // gallery03,
  // gallery04,
  knife,
  logo,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  gericht,
  Backend,
  bubble,
  navbar_bg,
  tempheader,
  mealIcon,
  customerIcon,
  starIcon,
};
